import React, { Component } from "react";

class TableBody extends Component {
    returnTableBody(name, tableData) {
        let tableRow = null;
        let signalProbability = 0;
        if (name === "Test1") {
            for (let i = 0; i < tableData.length; i++) {
                if (tableData[i].correct) {
                    signalProbability++;
                }
            }
        }
        switch (name) {
            case "Test1":
                tableRow = tableData.map((element, i) => {
                    console.log(element.userAnswer === "სიგნალი არის", element.userAnswerBool)
                    return (
                        <tr key={i}>
                            <td>{i + 1}</td>
                            <td>
                                {parseInt(
                                    Math.round(
                                        (signalProbability / tableData.length) *
                                            100
                                    )
                                )}
                            </td>
                            <td>{element.correct}</td>
                            <td>{element.total - element.correct}</td>
                            <td>
                                {element.correct >= 1
                                    ? "სიგნალი არის"
                                    : "სიგნალი არ არის"}
                            </td>
                            <td>{element.isUserAnswerCorrect ? "1" : "0"}</td>
                            <td>
                                {element.correct >= 1 && element.userAnswerBool == true
                                    ? 1
                                    : 0}
                            </td>
                            <td>
                                {element.correct === 0 && element.userAnswerBool == true
                                    ? 1
                                    : 0}
                            </td>
                        </tr>
                    );
                });
                break;
            case "Test2":
                tableRow = tableData.map((element, i) => {
                    console.log(element);
                    return (
                        <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{element.similarityType}</td>
                            <td>{element.isUserAnswerCorrect ? "1" : "0"}</td>
                            <td>{element.answerTime}</td>
                        </tr>
                    );
                });
                break;
            case "Test3":
                tableRow = tableData.map((element, i) => {
                    let Congruent;
                    console.log(element.text, element.color);
                    if (
                        (element.text == "ლურჯი" &&
                            element.color == "#0000ff") ||
                        (element.text == "მწვანე" &&
                            element.color == "#009933") ||
                        (element.text == "ყვითელი" &&
                            element.color == "#ffff00") ||
                        (element.text == "წითელი" && element.color == "#ff0000")
                    ) {
                        Congruent = "კონგრუენტული";
                    } else {
                        if (
                            (element.text == "ლურჯი" &&
                                element.color != "#0000ff") ||
                            (element.text == "მწვანე" &&
                                element.color != "#009933") ||
                            (element.text == "ყვითელი" &&
                                element.color != "#ffff00") ||
                            (element.text == "წითელი" &&
                                element.color != "#ff0000")
                        ) {
                            Congruent = "არაკონგრუენტული";
                        } else {
                            if (
                                element.text != "ლურჯი" ||
                                element.text != "მწვანე" ||
                                element.text != "ყვითელი" ||
                                element.text != "წითელი"
                            ) {
                                Congruent = "ნეიტრალური";
                            }
                        }
                    }

                    return (
                        <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{Congruent}</td>
                            <td>{element.isUserAnswerCorrect ? "1" : "0"}</td>
                            <td>{element.answerTime}</td>
                        </tr>
                    );
                });
                break;
            case "Test4":
                tableRow = tableData.map((element, i) => {
                    let style = null;
                    switch (element.margin) {
                        case "1":
                            style = { margin: "0" };
                            break;
                        case "2":
                            style = { margin: "0 20px" };
                            break;
                        case "3":
                            style = { margin: "0 85px" };
                            break;
                    }
                    let distractorType = null;
                    if (element.distractor === element.aimStimul) {
                        distractorType = "თავსებადი";
                    } else {
                        if (
                            element.distractor !== element.aimStimul &&
                            (element.distractor === "S" ||
                                element.distractor === "H")
                        ) {
                            distractorType = "არათავსებადი";
                        } else {
                            distractorType = "ნეიტრალური";
                        }
                    }

                    return (
                        <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{element.aimStimul}</td>
                            <td>{element.distractor}</td>
                            <td>
                                <p>
                                    <span>{element.distractor}</span>
                                    <span style={style}>
                                        {element.aimStimul}
                                    </span>
                                    <span>{element.distractor}</span>
                                </p>
                            </td>
                            <td>{distractorType}</td>
                            <td>{element.margin}</td>
                            <td>{element.answerTime}</td>
                            <td>{element.isUserAnswerCorrect ? "1" : "0"}</td>
                        </tr>
                    );
                });
                break;
            case "Test5":
                tableRow = tableData.map((element, i) => {
                    return (
                        <tr key={i}>
                            <td>ცდის ნომერი</td>
                            <td>სიგნალის ინტენსივობა</td>
                            <td>სიგნალის არსებობა</td>
                            <td>სისწორე</td>
                            <td>სწორი ამოცნობა</td>
                            <td>ცრუ განგაში</td>
                        </tr>
                    );
                });
                break;
            case "Test6":
                tableRow = tableData.map((element, i) => {
                    return (
                        <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{element.stimul}</td>
                            <td>{element.type === "type3" ? "4" : "2"}</td>
                            <td>{element.isUserAnswerCorrect ? "1" : "0"}</td>
                            <td>{element.answerTime}</td>
                        </tr>
                    );
                });
                break;
            case "Test7":
                tableRow = tableData.map((element, i) => {
                    return (
                        <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{element.degree}</td>
                            <td>{element.reverse}</td>
                            <td>
                                {isNaN(element.answerTime)
                                    ? element.answerTime
                                    : `${element.answerTime} მწმ`}
                            </td>
                            <td>{element.isUserAnswerCorrect ? "1" : "0"}</td>
                        </tr>
                    );
                });
                break;
            case "Test8": console.log(8); break;
            case "Test9":
                tableRow = tableData.map((element , i) => {

                    return (
                        <tr key = {i}>
                            <td>{element.number}</td>
                            <td>{element.sequenceSize}</td>
                            <td>{element.realAnswerString}</td>
                            <td>{element.stimPosition}</td>
                            <td>
                                {isNaN(element.answerTime)
                                    ? element.answerTime
                                    : `${element.answerTime} მწმ`}
                            </td>
                            <td>{element.isUserAnswerCorrect ? "1" : "0"}</td>
                        </tr>
                    )
                });
                
        }
        return tableRow;
    }

    render() {
        let tableData = this.props.tableBody;
        let name = this.props.name;
        console.log(tableData);
        let tableRow = this.returnTableBody(name, tableData);
        return <tbody>{tableRow}</tbody>;
    }
}

export default TableBody;
